// A billing approval or retry changes what the shell's count, Ops home and Approvals
// show. The sheet announces it here, and each of those reloads.
import { useEffect, useState } from "react";

const listeners = new Set<() => void>();

/** Tells every screen counting orders to bill that one was approved or retried. */
export function announceBillingChange(): void {
  for (const listener of listeners) listener();
}

/** A number that goes up each time billing changes, for use as a load dependency. */
export function useBillingChanges(): number {
  const [round, setRound] = useState(0);
  useEffect(() => {
    const bump = () => setRound((r) => r + 1);
    listeners.add(bump);
    return () => {
      listeners.delete(bump);
    };
  }, []);
  return round;
}
